import { Catalogue, ProductCard, Seo, ShopLayout } from 'components'
import { Page } from 'core/components'
import { GetStaticProps, InferGetStaticPropsType } from 'next'
import { Product } from 'model'
import { PRODUCT_FIELDS, getSanityClient } from '@resellam/sanity'
import { trackProducts } from 'lib/analytics'
import { siteMetadata } from 'core/utils'
import { useRouter } from 'next/router'
import { clickedProductIDs } from 'lib/algolia'
import { ReactElement } from 'react'
import { fetch, filter, order } from '@aonawale/sanity-query'

const getProductDeals = () =>
  fetch<Product[]>(
    getSanityClient(),
    {
      constraints: [
        filter('_type', '==', 'product'),
        filter('active', '==', true),
        filter('discount', '!=', null),
        filter('references(*[_type=="discount" && dateTime(endDate) >= dateTime(now())]._id)'),
        order('_updatedAt', 'asc'),
      ],
    },
    PRODUCT_FIELDS,
  )

interface DealsPageProps {
  products: Product[],
}

export const getStaticProps: GetStaticProps<DealsPageProps> = async () => ({
  props: {
    products: await getProductDeals(),
  },
})

const DealsPage = ({ products }: InferGetStaticPropsType<typeof getStaticProps>) => {
  const router = useRouter()

  return (
    <Page title="Deals" loading={router.isFallback} onClickBack={() => router.replace('/shop')}>
      <Seo
        title="Amazing Shop Deals."
        description={`Shop discounted phones, laptops, gadgets and more on ${siteMetadata.name}.`}
        canonical={`${siteMetadata.siteUrl}/shop/deals`}
      />
      <Catalogue>
        {products.map((product) => (
          <ProductCard
            key={product.id}
            href={`/shop/${product.slug}`}
            product={product}
            onClick={() => {
              clickedProductIDs([product.id], 'productClicked')
              trackProducts('shop_view_product', {
                productsListName: 'Deals',
                products: [product],
              })
            }}
          />
        ))}
      </Catalogue>
    </Page>
  )
}

DealsPage.getLayout = (page: ReactElement) => <ShopLayout>{page}</ShopLayout>

export default DealsPage
